export var LogLevel;
(function (LogLevel) {
    LogLevel["DEBUG"] = "debug";
    LogLevel["INFO"] = "info";
    LogLevel["WARN"] = "warn";
    LogLevel["ERROR"] = "error";
})(LogLevel || (LogLevel = {}));
class DefaultLogger {
    formatMessage(level, message, context) {
        const timestamp = new Date().toISOString();
        const contextStr = context ? ` ${JSON.stringify(context)}` : "";
        return `[${timestamp}] [${level.toUpperCase()}] ${message}${contextStr}`;
    }
    debug(message, context) {
        console.debug(this.formatMessage(LogLevel.DEBUG, message, context));
    }
    info(message, context) {
        console.info(this.formatMessage(LogLevel.INFO, message, context));
    }
    warn(message, context) {
        console.warn(this.formatMessage(LogLevel.WARN, message, context));
    }
    error(message, context) {
        console.error(this.formatMessage(LogLevel.ERROR, message, context));
    }
}
export const logger = new DefaultLogger();
